export default function isClickable(element) {
    if (element) {
        const targetNode = element.nodeName;
        const parentNode = element.parentElement && element.parentElement.nodeName;

        return (
            targetNode === 'INPUT' ||
            targetNode === 'TEXTAREA' ||
            targetNode === 'BUTTON' ||
            targetNode === 'A' ||
            parentNode === 'INPUT' ||
            parentNode === 'TEXTAREA' ||
            parentNode === 'BUTTON' ||
            parentNode === 'A' ||
            !!element.closest('.ui-button, .ui-checkbox, .ui-radiobutton') // @todo Add [data-pc-section="button"]
        );
    }

    return false;
}
